<script setup>
import { Link } from '@inertiajs/vue3';
const props = defineProps({
    href: {
        type: String,
        required: true,
    }
});
</script>

<template>
    <Link :href="href">
        <span class="sr-only">Old Country Store Fabrics</span>
        <img class="h-16 mt-1 w-16"
             src="/img/ocsf.png" alt="Old Country Store Fabrics"/>
    </Link>
</template>
